declare namespace $ {

	type $mol_text__text_rise_resize_ratio_demo_1 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio_demo['content'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $rise_resize_ratio__height_min_rise_resize_ratio_demo_2 = $mol_type_enforce<
		number
		,
		ReturnType< $rise_resize_ratio['height_min'] >
	>
	type $rise_resize_ratio__width_min_rise_resize_ratio_demo_3 = $mol_type_enforce<
		number
		,
		ReturnType< $rise_resize_ratio['width_min'] >
	>
	type $rise_resize_ratio__ratio_rise_resize_ratio_demo_4 = $mol_type_enforce<
		number
		,
		ReturnType< $rise_resize_ratio['ratio'] >
	>
	type $rise_resize_ratio__drag_body_rise_resize_ratio_demo_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $rise_resize_ratio['drag_body'] >
	>
	type $rise_resize_ratio__sticks_y_rise_resize_ratio_demo_6 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio_demo['sticks_y'] >
		,
		ReturnType< $rise_resize_ratio['sticks_y'] >
	>
	type $rise_resize_ratio__sticks_x_rise_resize_ratio_demo_7 = $mol_type_enforce<
		ReturnType< $rise_resize_ratio_demo['sticks_x'] >
		,
		ReturnType< $rise_resize_ratio['sticks_x'] >
	>
	type $mol_view__style_rise_resize_ratio_demo_8 = $mol_type_enforce<
		({ 
			'left': ReturnType< $rise_resize_ratio_demo['stick_left'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_rise_resize_ratio_demo_9 = $mol_type_enforce<
		({ 
			'top': ReturnType< $rise_resize_ratio_demo['stick_top'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	export class $rise_resize_ratio_demo extends $mol_example_small {
		height( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['height'] >
		width( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['width'] >
		top( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['top'] >
		left( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['left'] >
		x( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['x'] >
		y( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['y'] >
		bottom_edge_y( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['bottom_edge_y'] >
		right_edge_x( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['right_edge_x'] >
		top_edge_y( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['top_edge_y'] >
		left_edge_x( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['left_edge_x'] >
		x_stick( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['x_stick'] >
		y_stick( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['y_stick'] >
		bottom_edge_y_stick( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['bottom_edge_y_stick'] >
		right_edge_x_stick( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['right_edge_x_stick'] >
		top_edge_y_stick( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['top_edge_y_stick'] >
		left_edge_x_stick( ): ReturnType< ReturnType< $rise_resize_ratio_demo['Resize'] >['left_edge_x_stick'] >
		content( ): string
		Content( ): $mol_text
		sticks_y( ): readonly(any)[]
		sticks_x( ): readonly(any)[]
		Resize( ): $rise_resize_ratio
		sticks( ): readonly(any)[]
		stick_left( id: any): string
		stick_top( id: any): string
		sub( ): readonly(any)[]
		Stick_x( id: any): $mol_view
		Stick_y( id: any): $mol_view
		tags( ): readonly(any)[]
		aspects( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map